import { useCompleteInviteOnboardingMutation } from "@api/userOnboarding.api";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useScope } from "@state/scopeContext.lib";
import { FC, useCallback } from "react";
import { BaseOnboardingContainer } from "../components/BaseOnboardingContainer";
import { BillingOwnerInviteFlow } from "../flows/BillingOwnerInviteFlow";

export const BillingOwnerInviteOnboardingContainer: FC = () => {
    const completeInviteOnboardingMutation =
        useCompleteInviteOnboardingMutation();
    const navigate = useStateAwareNavigate();
    const { workspaceId, organizationId } = useScope();

    const onFinish = useCallback(async () => {
        await completeInviteOnboardingMutation.mutateAsync({
            workspaceId,
            organizationId,
        });

        navigate("/");
    }, [
        completeInviteOnboardingMutation,
        navigate,
        workspaceId,
        organizationId,
    ]);

    return (
        <BaseOnboardingContainer logoutButtonSize="lg">
            <BillingOwnerInviteFlow onFinish={onFinish} />
        </BaseOnboardingContainer>
    );
};
